function dissecateMenuContent(desc) {
  var toReturn = [];
  if (desc.indexOf('Entrée') !== -1) {
    var starter = {title: 'Entrée'};
    if (desc.indexOf('Plat') !== -1) {
      starter.value = desc.split('Plat')[0].split('Entrée')[1];
    } else if (desc.indexOf('Dessert') !== -1) {
      starter.value = desc.split('Dessert')[0].split('Entrée')[1];
    } else {
      starter.value = desc.split('Entrée')[1];
    }
    toReturn.push(starter);
  }
  if (desc.indexOf('Plat') !== -1) {
    var dish = {title: 'Plat'};
    if (desc.indexOf('Dessert') !== -1) {
      dish.value = desc.split('Dessert')[0].split('Plat')[1];
    } else {
      dish.value = desc.split('Plat')[1];
    }
    toReturn.push(dish);
  }
  if (desc.indexOf('Dessert') !== -1) {
    var dessert = {title: 'Dessert'};
    dessert.value = desc.split('Dessert')[1];
    toReturn.push(dessert);
  }
  return toReturn;
}


if ($(".js-convert-description").length > 0) {
  const trim = (str, chars) => str.split(chars).filter(Boolean).join(chars);
  $("body").find(".js-convert-description").each(function () {
    var description = $(this).html();
    var objTypes = dissecateMenuContent(description);
    var repDescr = "";
    for (var keyType in objTypes) {
      if (objTypes.hasOwnProperty(keyType)) {
        var trimed = trim(objTypes[keyType].value.trim(), ':');
        switch (objTypes[keyType].title) {
          case 'Entrée':
            repDescr += "<entree><span>Entrée</span><descr>" + trimed + "</descr></entree></br>";
            break;
          case 'Plat':
            repDescr += "<plat><span>Plat</span><descr>" + trimed + "</descr></plat></br>";
            break;
          case 'Dessert':
            repDescr += "<dessert><span>Dessert</span><descr>" + trimed + "</descr></dessert></br>";
            break;
          default:
            break;
        }
      }
    }
    $(this).html(repDescr);
  });
}

if($('.pd-container').length) {
  var intervalis = setInterval(function(){
    if($('#pd-consent .pd-section-title').text().indexOf('Acceptation ') !== -1){
      clearInterval(intervalis);
      var $elem = $('#pd-consent p.pd-no-consent-message');
      var txt = $elem.text();
      txt = txt.replace('https://corporate.tiptoque.com/pages/gdpr-e-privacy', '<a href="https://corporate.tiptoque.com/pages/gdpr-e-privacy">https://corporate.tiptoque.com/pages/gdpr-e-privacy</a>');
      $elem.html(txt);

      $elem = $('#pd-consent .pd-consent-message .pd-consent-message-text');
      txt = $elem.text();
      txt = txt.replace('https://corporate.tiptoque.com/pages/gdpr-e-privacy', '<a href="https://corporate.tiptoque.com/pages/gdpr-e-privacy">https://corporate.tiptoque.com/pages/gdpr-e-privacy</a>');
      $elem.html(txt);
    }
  }, 600);
}

$.fn.serializeObject = function(){

  var self = this,
      json = {},
      push_counters = {},
      patterns = {
        "validate": /^[a-zA-Z][a-zA-Z0-9_]*(?:\[(?:\d*|[a-zA-Z0-9_]+)\])*$/,
        "key":      /[a-zA-Z0-9_]+|(?=\[\])/g,
        "push":     /^$/,
        "fixed":    /^\d+$/,
        "named":    /^[a-zA-Z0-9_]+$/
      };


  this.build = function(base, key, value){
    base[key] = value;
    return base;
  };

  this.push_counter = function(key){
    if(push_counters[key] === undefined){
      push_counters[key] = 0;
    }
    return push_counters[key]++;
  };

  $.each($(this).serializeArray(), function(){
    // Skip invalid keys
    if(!patterns.validate.test(this.name)){
      return;
    }

    var k,
        keys = this.name.match(patterns.key),
        merge = this.value,
        reverse_key = this.name;

    while((k = keys.pop()) !== undefined){

      // Adjust reverse_key
      reverse_key = reverse_key.replace(new RegExp("\\[" + k + "\\]$"), '');

      // Push
      if(k.match(patterns.push)){
        merge = self.build([], self.push_counter(reverse_key), merge);
      }

      // Fixed
      else if(k.match(patterns.fixed)){
        merge = self.build([], k, merge);
      }

      // Named
      else if(k.match(patterns.named)){
        merge = self.build({}, k, merge);
      }
    }
    json = $.extend(true, json, merge);
  });

  return json;
};
